import common from '../common';

export default {
  jpath: ['spectra', 'uv'],
  find: common.basenameFind,
  getProperty: common.getTargetProperty,
};
